module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "wrapper",
    class: {
      'active': _vm.fieldFocused,
      'haserror': _vm.fieldError
    }
  }, [_c('div', {
    staticClass: "domains-name-field-wrapper"
  }, [_c('div', {
    staticClass: "w5-field-placeholder",
    class: {
      'active': _vm.fieldFocused || _vm.nameValue,
        'readonly': _vm.Field.readonly === true || _vm.nameField.readonly === true
    }
  }, [_vm._v("\r\n\t\t\t\t" + _vm._s(_vm._f("ftc")(_vm.nameField.title))), (_vm.nameField.required === true) ? _c('span', {
    staticClass: "required-field"
  }, [_vm._v(" *")]) : _vm._e()]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.nameValue),
      expression: "nameValue"
    }],
    ref: _vm.nameField._field_name,
    staticClass: "name-field",
    attrs: {
      "type": "text",
      "placeholder": "",
      "name": _vm.nameField._field_name,
      "disabled": _vm.nameField.readonly === true ? 'disabled' : false
    },
    domProps: {
      "value": (_vm.nameValue)
    },
    on: {
      "paste": function($event) {
        $event.preventDefault();
        return _vm.onNamePaste($event)
      },
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.nameValue = $event.target.value
      }, _vm.onNameChange],
      "focus": _vm.onNameFocus,
      "blur": _vm.onNameBlur,
      "keydown": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.enterKeyDown($event)
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "dot",
    class: {
      'active': _vm.nameValue
    }
  }, [_vm._v(".")])]), _vm._v(" "), _c('div', {
    staticClass: "domains-plan-field-wrapper"
  }, [_c('multiselect', {
    staticClass: "domains-plan-field",
    attrs: {
      "placeholder": "",
      "label": "fullName",
      "options": _vm.items && typeof _vm.items === 'object' && Array.isArray(_vm.items) ? _vm.items : [],
      "showLabels": false,
      "allowEmpty": false,
      "searchable": false,
      "disabled": _vm.Field.readonly === true ? true : false,
      "showNoOptions": false
    },
    on: {
      "open": _vm.onListOpen,
      "close": _vm.onListClose,
      "input": _vm.onPlanSelect
    },
    scopedSlots: _vm._u([{
      key: "option",
      fn: function(slotProps) {
        return _c('span', {
          staticClass: "domains-plan-option"
        }, [_c('strong', [_vm._v(_vm._s(slotProps.option.name))]), _vm._v(" "), (_vm.actionValue === 'register') ? _c('span', [_vm._v("\r\n\t\t\t\t\t\t" + _vm._s(_vm._f("moneyOnlyNumbers")(slotProps.option.cost)) + " "), _c('span', {
          domProps: {
            "innerHTML": _vm._s(_vm.localeFtc('main/ruble'))
          }
        }), _vm._v(" / " + _vm._s(slotProps.option.period_name) + "\r\n\t\t\t\t\t")]) : _vm._e(), _vm._v(" "), (slotProps.option.data && _vm.actionValue === 'transfer') ? _c('span', [_vm._v("\r\n\t\t\t\t\t\t" + _vm._s(_vm._f("moneyOnlyNumbers")(slotProps.option.data.Transfer)) + " "), _c('span', {
          domProps: {
            "innerHTML": _vm._s(_vm.localeFtc('main/ruble'))
          }
        })]) : _vm._e()])
      }
    }, {
      key: "singleLabel",
      fn: function(slotProps) {
        return _c('div', {
          staticClass: "domains-plan-label"
        }, [(slotProps.option && slotProps.option.name) ? [_c('div', {
          staticClass: "name"
        }, [_c('strong', [_vm._v(_vm._s(slotProps.option.name))])]), _vm._v(" "), _c('div', {
          staticClass: "info"
        }, [(slotProps.option.cost > 0 && _vm.actionValue === 'register') ? _c('div', [_vm._v("\r\n\t\t\t\t\t\t\t\t" + _vm._s(_vm._f("moneyOnlyNumbers")(slotProps.option.cost)) + " "), _c('span', {
          domProps: {
            "innerHTML": _vm._s(_vm.localeFtc('main/ruble'))
          }
        }), _vm._v(" / " + _vm._s(slotProps.option.period_name) + "\r\n\t\t\t\t\t\t\t")]) : _vm._e(), _vm._v(" "), (slotProps.option.data && slotProps.option.data.Transfer > 0 && _vm.actionValue === 'transfer') ? _c('div', [_vm._v("\r\n\t\t\t\t\t\t\t\t" + _vm._s(_vm._f("moneyOnlyNumbers")(slotProps.option.data.Transfer)) + " "), _c('span', {
          domProps: {
            "innerHTML": _vm._s(_vm.localeFtc('main/ruble'))
          }
        })]) : _vm._e()])] : _vm._e()], 2)
      }
    }]),
    model: {
      value: (_vm.planValue),
      callback: function($$v) {
        _vm.planValue = $$v
      },
      expression: "planValue"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "wrapper for-error"
  }, [(_vm.fieldError) ? _c('div', {
    directives: [{
      name: "withSafeTags",
      rawName: "v-withSafeTags",
      value: (_vm.localeFtc(_vm.fieldError)),
      expression: "localeFtc(fieldError)"
    }],
    staticClass: "alert alert-danger w5-alert-valid",
    attrs: {
      "role": "alert"
    }
  }) : _vm._e()])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d993f8e8"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/elements/planDomain.vue
// module id = 373
// module chunks = 0